import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BsArrowLeft } from "react-icons/bs";

const BackButton = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // Go back one step in the history stack
  };

  return (
    <button className='backbtn' onClick={goBack}><BsArrowLeft/></button>
  );
};

export default BackButton;
